var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEsproLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 267.52,
    height: 62,
    viewBox: "0 0 267.52 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "white_espro_logo",
    "data-name": "white espro logo",
    transform: "translate(-132.052 -143.893)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M168.862,145.5h-35.32a1.423,1.423,0,0,0-1.49,1.6v56.362a1.424,1.424,0,0,0,1.49,1.6h35.32a1.423,1.423,0,0,0,1.486-1.6v-4.143a1.423,1.423,0,0,0-1.486-1.6H140.136V178.545h23.617a1.42,1.42,0,0,0,1.486-1.6V172.8a1.423,1.423,0,0,0-1.486-1.6H140.136V152.852h28.726a1.421,1.421,0,0,0,1.486-1.6V147.1A1.421,1.421,0,0,0,168.862,145.5Z",
    transform: "translate(0 -0.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M221.845,173.329l-12.769-4.141c-6.108-2.013-8.6-4.679-8.6-9.2,0-5.4,4.6-8.752,12.017-8.752,7.191,0,11.988,3.388,13.873,9.8a1.631,1.631,0,0,0,1.6,1.379h4.6a1.436,1.436,0,0,0,1.141-.49,1.725,1.725,0,0,0,.332-1.424c-1.972-10.556-9.824-16.61-21.543-16.61-12.021,0-20.1,6.634-20.1,16.508,0,7.954,4.23,13.206,12.934,16.06l12.78,4.143h0c5.966,1.932,8.512,4.683,8.512,9.2,0,5.479-4.765,8.749-12.746,8.749s-12.982-3.3-14.889-9.8a1.621,1.621,0,0,0-1.6-1.382h-4.6a1.432,1.432,0,0,0-1.133.484,1.733,1.733,0,0,0-.34,1.422c2,10.714,10.012,16.614,22.562,16.614,12.652,0,20.827-6.478,20.827-16.5C234.7,181.483,230.376,176.079,221.845,173.329Z",
    transform: "translate(-13.305)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M285.658,145.5H264.492a1.421,1.421,0,0,0-1.486,1.6v56.362a1.423,1.423,0,0,0,1.486,1.6H269.6a1.423,1.423,0,0,0,1.486-1.6V186h14.57c12.727,0,19.736-7.191,19.736-20.249S298.385,145.5,285.658,145.5Zm0,33.152h-14.57v-25.8h14.57c7.514,0,11.653,4.582,11.653,12.9S293.172,178.655,285.658,178.655Z",
    transform: "translate(-29.423 -0.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M428.553,143.9c-16.737,0-30.354,13.906-30.354,31s13.617,31,30.354,31,30.353-13.906,30.353-31S445.289,143.9,428.553,143.9Zm0,53.936a22.942,22.942,0,1,1,22.459-22.937A22.728,22.728,0,0,1,428.553,197.831Z",
    transform: "translate(-59.333 -0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M368.339,187.751c-.784-1.392-2.963-5.225-4.5-7.824,7.017-2.621,11.174-8.477,11.174-15.836,0-11.64-7.377-18.589-19.732-18.589H334.847a1.424,1.424,0,0,0-1.493,1.6v56.362a1.426,1.426,0,0,0,1.493,1.6h5.1a1.423,1.423,0,0,0,1.487-1.6V182.69l14.443,0,3.493,5.835,8.762,15.336a2.05,2.05,0,0,0,1.74,1.208h5.986a1.42,1.42,0,0,0,1.369-.661,1.463,1.463,0,0,0-.134-1.5Zm-1.411-23.659c0,7.044-4.356,11.25-11.652,11.25H341.435V152.848h13.841C362.572,152.848,366.928,157.051,366.928,164.092Z",
    transform: "translate(-45.2 -0.393)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsproLogo);
export default __webpack_public_path__ + "static/media/espro-logo.1a8649233316d33f5105f9e9269ca552.svg";
export { ForwardRef as ReactComponent };